var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1H18C20.2091 1 22 2.79086 22 5V14C22 16.2091 20.2091 18 18 18H5C2.79086 18 1 16.2091 1 14V5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.05736L28 4V15L22 11.9426V7.05736Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1H18C20.2091 1 22 2.79086 22 5V14C22 16.2091 20.2091 18 18 18H5C2.79086 18 1 16.2091 1 14V5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.05736L28 4V15L22 11.9426V7.05736Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconSelected);
export default __webpack_public_path__ + "static/media/video-icon-selected.6f16ce7ff399e6fbe8a8f09d9ae50fd1.svg";
export { ForwardRef as ReactComponent };